import { apiFetch } from "./client";
import type { PaginatedItems, ItemDetail, ItemFilters, BulkActionRequest, BulkActionResponse } from "../types";

export async function fetchItems(filters: ItemFilters): Promise<PaginatedItems> {
  const params = new URLSearchParams();
  params.set("page", String(filters.page));
  params.set("page_size", String(filters.page_size));
  if (filters.tag) params.set("tag", filters.tag);
  if (filters.exclude_tag) params.set("exclude_tag", filters.exclude_tag);
  if (filters.min_score !== undefined) params.set("min_score", String(filters.min_score));
  if (filters.max_score !== undefined) params.set("max_score", String(filters.max_score));
  if (filters.is_read !== undefined) params.set("is_read", String(filters.is_read));
  if (filters.q) params.set("q", filters.q);
  if (filters.from_date) params.set("from_date", filters.from_date);
  if (filters.to_date) params.set("to_date", filters.to_date);
  if (filters.status) params.set("status", filters.status);
  if (filters.source_id !== undefined) params.set("source_id", String(filters.source_id));

  return apiFetch<PaginatedItems>(`/items?${params.toString()}`);
}

export async function fetchItem(id: number): Promise<ItemDetail> {
  return apiFetch<ItemDetail>(`/items/${id}`);
}

export async function markItemRead(id: number, isRead: boolean): Promise<ItemDetail> {
  return apiFetch<ItemDetail>(`/items/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ is_read: isRead }),
  });
}

export async function updateItemStatus(id: number, status: string): Promise<ItemDetail> {
  return apiFetch<ItemDetail>(`/items/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}

export async function deleteItem(id: number): Promise<void> {
  await apiFetch<void>(`/items/${id}`, { method: "DELETE" });
}

export async function bulkAction(request: BulkActionRequest): Promise<BulkActionResponse> {
  return apiFetch<BulkActionResponse>("/items/bulk", {
    method: "POST",
    body: JSON.stringify(request),
  });
}
